module.exports = __webpack_public_path__ + "static/img/bigwork.34b0ae79.png";